import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const finalizeAnnualClientActivityReview = async (payload) => {
    try {
        const token = Cookies.get("Bearer");
        const response = await axios.post(
            `${FIRMFLOWURL}api/Client/${payload.clientId}/annual-review/finalize-inactive`,
            payload,
            { headers: { Authorization: token } },
        );

        return { ...response, success: true };
    } catch (error) {
        if (error?.response?.status === 401) {
            Cookies.remove("Bearer");
            window.location.replace("/");
            return { success: false, status: 401 };
        }

        return {
            success: false,
            status: error?.response?.status,
            data: error?.response?.data,
            message:
                error?.response?.data?.message ||
                error?.message ||
                "The Semiannual Client Review could not be finalized.",
        };
    }
};
